// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"86de0bc5","664":"86de0bc5"}[chunkId] + ".chunk.css";
};